<div class="tabs-container">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="Not Submitted">
            <ag-grid-angular class="data-grid " [gridOptions]="notSubmittedGridOptions" [rowData]="notSubmittedData"  [attr.aria-label]="widgetTitle + ' - Not Submitted'"></ag-grid-angular>
        </tab>
        <tab title="Pending">
            <ag-grid-angular class="data-grid " [gridOptions]="pendingGridOptions" [rowData]="pendingData"  [attr.aria-label]="widgetTitle + ' - Pending'"></ag-grid-angular>
        </tab>
        <tab title="Inspection">
            <ag-grid-angular class="data-grid " [gridOptions]="inspectionGridOptions" [rowData]="inspectionData"  [attr.aria-label]="widgetTitle + ' - Inspection'"></ag-grid-angular>
        </tab>
        <tab title="First">
            <ag-grid-angular class="data-grid " [gridOptions]="firstReviewGridOptions" [rowData]="firstReviewData"  [attr.aria-label]="widgetTitle + ' - First'"></ag-grid-angular>
        </tab>
        <tab title="Final">
            <ag-grid-angular class="data-grid " [gridOptions]="finalReviewGridOptions" [rowData]="finalReviewData"  [attr.aria-label]="widgetTitle + ' - Final'"></ag-grid-angular>
        </tab>
        <tab title="Approved">
            <ag-grid-angular class="data-grid " [gridOptions]="approvedGridOptions" [rowData]="approvedData"  [attr.aria-label]="widgetTitle + ' - Approved'"></ag-grid-angular>
        </tab>
        <tab title="Denied">
            <ag-grid-angular class="data-grid " [gridOptions]="deniedGridOptions" [rowData]="deniedData"  [attr.aria-label]="widgetTitle + ' - Denied'"></ag-grid-angular>
        </tab>
    </tabs>
</div>